<script setup lang="ts">

import {Branch} from "../../types/branch";

const branch: Branch = {
    branch_id: 1,
    branch_name: 'Bratislava, Galvaniho 7/B - CBC Slovakia s.r.o.',
    branch_street: 'Galvaniho 7/B',
    branch_city: 'Bratislava',
    branch_zip_code: '821 04',
    branch_url: 'https://www.cbcslovakia.sk/kontakty',
    branch_phone: '+421 850 11 15 15',
    branch_email: 'dispecing@cbcslovakia.sk',
}

</script>

<template>
    <div class="p-6 rounded w-full bg-gray-lighter">
        <div class="flex flex-col">
            <div class="flex flex-row justify-between">
                <div>
                    <h4 class="text-base font-bold">{{ branch.branch_name }}</h4>
                    <p class="text-sm text-gray font-medium">{{ branch.branch_street }}, {{ branch.branch_city }}</p>
                </div>

                <a class="flex flex-row gap-2 items-center mt-6 no-underline" :href="branch.branch_url" target="_blank">
                    <span class="text-sm md:text-base !text-red">Viac</span>
                    <img class="!p-0 !m-0" src="../../public/icons/arrow-right.svg" alt="Šípka vpravo" aria-hidden="true">
                </a>
            </div>

            <div class="flex flex-col sm:flex-row gap-2 sm:gap-10 text-sm font-medium">
                <div class="flex flex-row gap-2 items-center" aria-label="Telefónne číslo">
                    <img class="w-4 !p-0 !m-0" src="../../public/icons/phone.svg" alt="Ikona telefónneho čísla" aria-hidden="true">
                    <a :href="`tel:${branch.branch_phone}`" class="text-gray no-underline hover:underline">{{ branch.branch_phone }}</a>
                </div>
                <div class="flex flex-row gap-2 items-center" aria-label="E-mail">
                    <img class="w-4 !p-0 !m-0" src="../../public/icons/mail.svg" alt="Ikona e-mailu" aria-hidden="true">
                    <a :href="`mailto:${branch.branch_email}`" class="text-gray no-underline hover:underline">{{ branch.branch_email }}</a>
                </div>
            </div>
        </div>
    </div>
</template>
